import React, { Component } from 'react';
import { connect } from 'react-redux';
import LastNews from "../../lastnews/lastnews.component";
import {API_URL} from "../../../../SHARED/config/apiEndpoints";
import { requestLastNews } from '../../../../SHARED/actions/news.actions';

class PortretNewsContainer extends Component {

    componentWillMount() {
        this.props.requestLastNews();
    }

    getLatestNews = () => {
        return this.props.lastNews.map((nw, i) => {
            return (
                <div key={i}>
                    <LastNews
                        id={ nw.article_id }
                        image={ API_URL + nw.article_image }
                        title={ nw.article_title }
                        date={ nw.article_created }
                        description={ nw.article_summary }
                    />
                </div>
            );
        });
    };

    render() {
        return (
            <div className="last-news-container">
                <p className="underline-text white-text">ULTIMELE ȘTIRI ADĂUGATE</p>
                { this.getLatestNews() }
            </div>
        );
    }
}

const mapStateToProps = state => ({
    lastNews: state.news.lastNews
});
export default connect(mapStateToProps, {requestLastNews})(PortretNewsContainer);



// WEBPACK FOOTER //
// ./src/FO/components/news/containers/portretnewscontainer.component.js